import { replaceChildrenText } from "./replace-children-text.js";
import { createRichTextComponents } from "./create-rich-text-components.js";
import { getAccentTextFillEndMilliseconds } from "./get-accent-text-fill-end-milliseconds.js";
import { RichText } from "./RichText.js";

export { RichText, createRichTextComponents, getAccentTextFillEndMilliseconds, replaceChildrenText };